import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { InvestimentBrokerComponent } from './investiment-broker.component';
import { ButtonModule } from 'src/app/shared/component/common/button/button.module';
import { HeaderModule } from 'src/app/shared/component/common/header/header.module';
import { LabelModule } from 'src/app/shared/component/common/label/label.module';
import { RadioModule } from 'src/app/shared/component/common/radio/radio.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    RadioModule
  ],
  declarations: [InvestimentBrokerComponent]
})
export class InvestimentBrokerModule {}
